<script lang="ts">
    import Icon from "@components/Icon.svelte";

    //Props
    export let isOpen: boolean;
</script>

<Icon width="24" height="24" viewBox="0 0 24 24">
    <line
        x1="4"
        y1="12"
        x2="20"
        y2="12"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
    />
    <line
        x1="12"
        y1="4"
        x2="12"
        y2="20"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        class:is-hidden={isOpen}
    />
</Icon>

<style>
    .is-hidden {
        opacity: 0;
        transition: opacity 0.2s ease-in-out;
    }
</style>
